"use client"
import Link from 'next/link';
import { Button } from '../ui/button';
import Icons from '../ui/icons';
import Menu from './menu';
import MobileNavbar from './mobile-navbar';
import { RainbowBanner } from '../utils/BannerNav';
import { signOut, useSession } from 'next-auth/react';
import { Skeleton } from '../ui/skeleton';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { roles } from '@/lib/utils';
import Image from 'next/image';
import { useCart } from '../providers/CartContext';
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '../ui/sheet';
import CartSheetContent from '../contents/CartSheetContent';

const Navbar = () => {
    const { data: session, status } = useSession()
    const { items } = useCart()
    return (
        <>

            <RainbowBanner />
            <header className="fixed inset-x-0 top-0 z-[999] w-full h-16 backdrop-blur-lg b-background/50 bg-[rgba(4,1,2,0.2)] flex border-b-[1px] border-[#1C1B1D]">
                {/* Desktop */}
                <div className="hidden lg:flex items-center justify-between w-full px-4 mx-auto lg:px-8 max-w-7xl">
                    <div className="flex items-center justify-between w-full flex-nowrap">
                        <div className="flex items-center flex-1 lg:flex-none">
                            <Link href="/" className="text-lg  text-gray-300">
                                بازیتور
                            </Link>
                            <div className="items-center hidden ml-4 lg:flex">
                                <Menu />
                            </div>
                        </div>
                        <div className="items-center hidden lg:flex gap-x-2">
                            <Sheet>
                                <SheetTrigger className="relative">
                                    <div className='border-[#4e2b754f]  rounded-xl bg-[#3c2a4d80] p-2 border-[1px] '>
                                        <Icons.cart className="w-[21px] h-[21px]" />
                                    </div>
                                    {items.length > 0 && (
                                        <span className="absolute -top-1 -right-1 text-xs bg-purple-600 text-white rounded-full w-4 h-4 flex items-center justify-center">
                                            <p className='text-xs pt-[2px]'>{items.length}</p>
                                        </span>
                                    )}
                                </SheetTrigger>
                                <SheetContent className="bg-background p-4 w-full max-w-2xl z-[1000]">
                                    <SheetTitle>سبد خرید</SheetTitle>
                                    <CartSheetContent />
                                </SheetContent>
                            </Sheet>

                            {status === 'loading' ? (
                                <div className="flex gap-2 items-center space-x-4">
                                    <Skeleton className="h-10 w-10 rounded-xl" />
                                    <div className="space-y-2">
                                        <Skeleton className="h-2 w-[120px]" />
                                        <Skeleton className="h-2 w-[80px]" />
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {status === 'authenticated' ? (
                                        <DropdownMenu>
                                            <DropdownMenuTrigger className='cursor-pointer rounded-2xl p-1' asChild>
                                                <div className="flex gap-2 items-center justify-center space-x-4">

                                                    <Image src={session?.user?.profile || `/images/2.png`} alt='عکس پروفایل' width={1000} height={1000} className='h-10 w-10 p-1 border-[1px] border-[#4e2b754f]  rounded-xl bg-[#3c2a4d80]' />

                                                    <div className="">
                                                        <div className=" w-[120px] text-sm text-gray-300"><p>{session.user.username}</p></div>
                                                        <div className=" w-[160px] text-xs text-gray-300"><p>بعنوان {roles[session.user.role || 'user']} وارد شدید</p></div>
                                                    </div>
                                                </div>
                                            </DropdownMenuTrigger>
                                            <DropdownMenuContent className="w-56 border-b-[1px] border-[#1C1B1D]">
                                                <DropdownMenuLabel>منوی کاربری</DropdownMenuLabel>
                                                <DropdownMenuSeparator />
                                                <DropdownMenuGroup>
                                                    <DropdownMenuItem>
                                                        پروفایل
                                                    </DropdownMenuItem>
                                                    <DropdownMenuItem>
                                                        سفارشات
                                                    </DropdownMenuItem>
                                                    <DropdownMenuItem>
                                                        تنظیمات
                                                    </DropdownMenuItem>
                                                    <DropdownMenuItem>
                                                        تیکت پشتیبانی
                                                    </DropdownMenuItem>
                                                </DropdownMenuGroup>
                                                <DropdownMenuSeparator />
                                                <DropdownMenuItem>تلگرام</DropdownMenuItem>
                                                <DropdownMenuItem>اینستاگرام</DropdownMenuItem>
                                                <DropdownMenuItem disabled>مستندات سایت</DropdownMenuItem>
                                                <DropdownMenuSeparator />
                                                <DropdownMenuItem onClick={() => signOut()}>
                                                    خروج
                                                </DropdownMenuItem>
                                            </DropdownMenuContent>
                                        </DropdownMenu>
                                    ) : (
                                        <div className='flex flex-row gap-2'>
                                            <Button size="sm" variant="secondary" asChild>
                                                <Link href="/auth/signin">
                                                    ورود
                                                </Link>
                                            </Button>
                                            <Button size="sm" variant="secondary" asChild>
                                                <Link href="/auth/signup">
                                                    ثبت نام
                                                </Link>
                                            </Button>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* Mobile */}
                <MobileNavbar />

            </header>
        </>
    )
};

export default Navbar
